import imageUrlBuilder from "@sanity/image-url";
import { client } from "@service/sanity";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";

const builder = imageUrlBuilder(client);

const urlFor = (src: SanityImageSource) => builder.image(src);

export default urlFor;
